import {Component, HostListener} from "@angular/core";
import {FUIEventsService} from "../events/events.service";

/*
Contains dynamically injected component placeholders
 */
@Component({
    selector: "fui-injectables",
    styleUrls: ["./injectables.component.scss"],
    templateUrl: "./injectables.component.html"
})
export class FUIInjectablesComponent {
    constructor(private eventsService: FUIEventsService) {
    }

    /**
     * See FUICanvasComponent.
     * @param {MouseEvent} mouseEvent
     */
    @HostListener("click", ["$event"])
    public click(mouseEvent: MouseEvent): void {
        mouseEvent.stopPropagation();
        this.eventsService.click = mouseEvent;
    }

    @HostListener("mousedown", ["$event"])
    public mousedown(mouseEvent: MouseEvent): void {
        mouseEvent.stopPropagation();
        this.eventsService.click = mouseEvent;
    }
}
